import ProtectedRoute from 'uplisting-frontend/pods/base/protected-route';

export default class ConnectIndexRoute extends ProtectedRoute {
  redirect(): void {
    this.router.replaceWith('connect.all');
  }
}
